import permissions from "../config/permissions";

const { default: store } = require("../store");

const hasSubArray = (master, sub) => {
  let contains = false;
  sub.forEach((subPermission) => {
    if (master.includes(subPermission)) {
      contains = true;
    }
  });
  return contains
};

export const checkPermission = (permissions) => {
  const userPermissions = store.getState()?.authUser?.permissions;
  if (!userPermissions) {
    return false;
  } else if (hasSubArray(userPermissions, permissions)) {
    return true;
  }
  return false;
};

export const CheckPermissionRender = ({ permissions, children }) => {
  return checkPermission(permissions) ? children : null;
};

export const getIsSuperAdmin = () => {
  return checkPermission(permissions().organization().read().list());
}